import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params}  from '@angular/router';
import { Headers, Http,Response,RequestOptions  } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { APPCONFIG } from '../config'
import { HttpService } from '../shared/services/http.service'
import { ErrorHandler } from '../shared/services/error-handler.service'
import { CommonService } from '../shared/services/common.service'
import { SessionHandler } from '../shared/services/session-handler.service'
	
@Injectable()
export class FOCRequestService {
	
  	private headers = new Headers({'Content-Type': 'application/json','access-token':this.sessionHandler.getItem('token')});
	
	constructor(private myHttp:Http, private router: Router, private httpService:HttpService, private errorHandler:ErrorHandler, private commonService:CommonService, public sessionHandler:SessionHandler) {}
	
	

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-requests.service.ts